// reusing this to create a new error id
import { newId } from "@dashboard/firebaseMethods/newId";
import { type ReduxState } from "@dashboard/types/reduxState";

// Actions for showing errors
export type ErrorReducerAction =
  | { type: "ADD_ERROR"; payload: string; isUserFacing: boolean } // Add an error to the list of errors.
  | { type: "REMOVE_ERROR"; errorId: string }; // Remove the error with the given id.

export const errorReducer: (
  state: ReduxState["error"] | undefined,
  action: ErrorReducerAction
) => ReduxState["error"] = (
  state: ReduxState["error"] = {
    errors: [],
  },
  action: ErrorReducerAction
) => {
  switch (action.type) {
    case "ADD_ERROR":
      return {
        ...state,
        errors: [
          ...state.errors,
          {
            errorId: newId(),
            message: action.payload,
            isUserFacing: action.isUserFacing,
          },
        ],
      };
    case "REMOVE_ERROR":
      return {
        ...state,
        errors: state.errors.filter(
          (error) => error.errorId !== action.errorId
        ),
      };
    default:
      return state;
  }
};
